<div class="page-header-container">
    <div class="page-title">{{ 'insurance.insuranceList.title' | translate }}</div>
</div>
<div class="header-buttons-box">
    <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
        <div class="btn-group" role="group">
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                <span>{{ 'common.listView' | translate }}</span>
            </button>
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                <span>{{ 'common.cardsView' | translate }}</span>
            </button>
        </div>
    </div>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasData">
    <no-records-placeholder
        [showNoRecordsHeader]="true">
    </no-records-placeholder>
</div>

<insurance-card-view     
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp) && hasData"
    [insurances]="insurances" 
    [props]="props">  
</insurance-card-view>
<insurance-list-view
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp) && hasData"
    [insurances]="insurances" 
    [props]="props">
</insurance-list-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>
